import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuth";
import "../Admin.css";

const navSections = [
  {
    title: "Main",
    items: [
      { label: "Dashboard", to: "/admin", icon: "fa-solid fa-gauge" },
    ],
  },
  {
    title: "Blogs",
    items: [
      { label: "Add Blog", to: "/admin/add-blog", icon: "fa-solid fa-square-plus" },
      { label: "View Blogs", to: "/admin/view-blogs", icon: "fa-solid fa-eye" },
      { label: "SEO Files", to: "/admin/seo-files", icon: "fa-solid fa-file-lines" },
      { label: "SEO Meta", to: "/admin/seo-meta", icon: "fa-solid fa-globe" },
          { label: "Analytics", to: "/admin/analytics", icon: "fa-solid fa-chart-line" },
    ],
  },
];

function AdminLayout() {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <div className="admin-logo">AN</div>
          <div>
            <div className="admin-brand-title">Ashok Nanda</div>
            <div className="admin-brand-text">Admin</div>
          </div>
        </div>

        <div className="admin-nav">
          {navSections.map((section) => (
            <div key={section.title} className="admin-nav-section">
              <div className="admin-nav-heading">{section.title}</div>
              {section.items.map((item) => (
                <NavLink
                  key={item.label}
                  to={item.to}
                  className={({ isActive }) =>
                    `admin-nav-link${isActive ? " active" : ""}`
                  }
                >
                  <i className={`${item.icon} admin-nav-icon`} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </div>

        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-nav-link logout-link"
            onClick={handleLogout}
          >
            <i className="fa-solid fa-right-from-bracket admin-nav-icon" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <div>
            <h1>Blog Management</h1>
            <p className="admin-topbar-note">
              Clean, focused admin tools for adding and managing content.
            </p>
          </div>
          <div className="admin-user-card">
            <div className="admin-user-avatar">A</div>
            <div>
              <div className="admin-user-name">Admin</div>
              <div className="admin-user-role">Administrator</div>
            </div>
          </div>
        </div>

        <section className="admin-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}

export default AdminLayout;
